<template>
	<div>
		<myHeader></myHeader>
		<appMain></appMain>
		<!-- <myFooter></myFooter> -->
	</div>
</template>

<script>
import myHeader from "@/pages/layout/header.vue";
import appMain from "@/pages/layout/AppMain.vue";
import myFooter from "@/pages/layout/footer.vue";

export default {
    components: { myHeader, appMain, myFooter },
    data() {
        return {
            list: []
        };
    }
};
</script>

<style>
body,
html {
    background-color: #f3f3f3;
}
</style>




// WEBPACK FOOTER //
// src/pages/layout/layout.vue